import SendSMSProvider from '../providers/send-sms-provider';

class SendSMSRepository {

    constructor() {
        this.sendSMSProvider = new SendSMSProvider();
    }

    enviarSMS = async (datosEnvioSMS) => {
        return this.sendSMSProvider.enviarSMS(datosEnvioSMS);
    }

}

export default SendSMSRepository;